import { PricingScopeUser } from './types';

export function filterAvailablePricingUsers(users: PricingScopeUser[], assignedUserIds: number[], search: string): PricingScopeUser[] {
  const assigned = new Set(assignedUserIds);
  const normalizedSearch = search.trim().toLocaleLowerCase('pt-BR');

  return users.filter(user => {
    if (assigned.has(user.cdUsuario)) return false;
    if (!normalizedSearch) return true;

    return user.name.toLocaleLowerCase('pt-BR').includes(normalizedSearch) || user.email.toLocaleLowerCase('pt-BR').includes(normalizedSearch);
  });
}
